export default {


  Sample:[ // Dashboard Only 
  
  {
      name: '優惠兌換',
      url: '/dashboard/redemption',
      icon: 'fa-gift'
    },
    {
      name: '註冊登記',
      url: '/dashboard/registration',
      icon: 'fa-id-card'
    },
  ],

  admin:[ // Dashboard Only 
  
  {
      name: '優惠兌換',
      url: '/dashboard/redemption',
      icon: 'fa-gift'
    },
    {
      name: '註冊登記',
      url: '/dashboard/registration',
      icon: 'fa-id-card'
    },
    // {
    //   name: '登記商店管理',
    //   url: '/dashboard/store',
    //   icon: 'fa-home'
    // },
    // {
    //   name: '購買商店管理',
    //   url: '/dashboard/staticStore',
    //   icon: 'fa-home'
    // },
    {
      name: '商店管理',
      url: '/dashboard/finalStore',
      icon: 'fa-map-marker'
    },
    {
      name: '發送SMS',
      url: '/dashboard/smsBatch',
      icon: 'fa-envelope'
    },
  ],

  // NavItems for Root Role
  Root: [{
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
    // {
    //   name: 'quick.renewal.header',
    //   url: '/quick',
    //   icon: 'fa-retweet'
    // },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/profile'
      }]
    },
    {
      name: 'crm.title',
      url: '/crm/lead',
      icon: 'fa-users',
      children: [{
          name: 'crm.lead.header',
          icon: 'fa-leaf',
          url: '/crm/lead/list'
        }, {
          name: 'crm.customer.header',
          icon: 'fa-address-book',
          url: '/crm/customer/list'
        },
        {
          name: 'crm.calendar.header',
          icon: 'fa-calendar-alt',
          url: '/crm/calendar'
        },
        {
          name: 'crm.Notification.header',
          icon: 'fa-bell',
          url: '/crm/notification'
        }
      ]
    },

    {
      name: 'osm.title',
      url: '/osm',
      icon: 'fa-asterisk',
      children: [{
          name: 'osm.contents.giPolicy.header',
          icon: 'fa-code-branch',
          url: '/osm/gi/list'
        }, {
          name: 'osm.contents.lifePolicy.header',
          icon: 'fa-heart',
          url: '/osm/life/list'
        },
        {
          name: 'osm.serviceRequest.header',
          icon: 'fa-concierge-bell',
          url: '/osm/sr/list'
        },
        {
          name: 'osm.claim.header',
          icon: 'fa-retweet',
          url: '/osm/claim/list'
        },
        {
          name: 'osm.renewal.quickRenew',
          icon: 'fa-retweet',
          url: '/osm/renewal/renew',
        },
        // {
        //   name: 'osm.provider.header',
        //   icon: 'fa-building',
        //   url: '/osm/provider/list'
        // },
        // {
        //   name: 'osm.product.header',
        //   icon: 'fa-file-contract',
        //   url: '/osm/product/list'
        // },
        {
          name: 'x U Life Policy (TBC)',
          title: true,
          icon: '',
        },
        {
          name: 'x ILAS (TBC)',
          title: true,
          icon: '',
        }
      ]
    },
    {
      name: 'dw.header',
      url: '/dw',
      icon: 'fa-warehouse',
      children: [{
          name: 'dw.report.header',
          title: true,
          icon: 'fa-file',
          children: [{
              name: 'dw.report.birthday.header',
              url: '/dw/report/birthday',
              icon: 'fa-chart-line'
            },
            {
              name: 'dw.report.customer.header',
              url: '/dw/report/customer',
              icon: 'fa-users'
            },
            {
              name: 'dw.report.performance.header',
              url: '/dw/report/performance',
              icon: 'fa-chart-line'
            },
            {
              name: 'dw.report.sale.header',
              url: '/dw/report/sale',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.agentCommission.header',
              url: '/dw/report/fc-commission',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.companyCommission.header',
              url: '/dw/report/company-commission',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.renewal.header',
              url: '/dw/report/renewal',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.giPolicy.header',
              url: '/dw/report/giPolicy',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.lifePolicy.header',
              url: '/dw/report/lifePolicy',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.claim.header',
              url: '/dw/report/claim',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.sr.navHeader',
              url: '/dw/report/sr',
              icon: 'fa-credit-card'
            },
            // {
            //   name: 'dw.report.commission.header',
            //   url: '/dw/report/commission',
            //   icon: 'fa-credit-card'
            // }
          ]
        },
        {
          name: 'dw.form.header',
          title: true,
          icon: 'fa-download',
          url: '/dw/form/list'
        }
      ]
    },
    {
      name: 'adm.header',
      url: '/adm',
      icon: 'fa-briefcase',
      children: [{
          name: 'adm.cpd.cpd',
          icon: 'fa-school',
          title: true,
          children: [{
              name: 'adm.cpd.list.shortHeader',
              url: '/adm/cpd/list',
              icon: 'fa-calendar-plus'
            },
            {
              name: 'adm.cpd.agentShortHeader',
              url: '/adm/cpd/agent',
              icon: 'fa-star-half-alt'
            }
          ]
        }, {
          name: 'adm.userAuthorization.title',
          icon: 'fa-user-secret',
          url: '/adm/authorization',
          // title: true
        },
        {
          name: 'adm.agent.header',
          url: '/adm/agent/list',
          icon: 'fa-list-ol',
        },
        {
          name: 'adm.agentCommission.header',
          url: '/adm/agent-commission',
          icon: 'fa-list-ol',
        },
        {
          name: 'adm.companyCommission.header',
          url: '/adm/company-commission',
          icon: 'fa-list-ol'
        },
        {
          name: 'adm.team.header',
          url: '/adm/team/list',
          icon: 'fa-list-ol',
        },
        {
          name: 'adm.auditTrail.title',
          icon: 'fa-database',
          url: '/adm/audit-trail',
          // title: true
        },
        {
          name: 'adm.bulletin.title',
          icon: 'fa-database',
          url: '/adm/bulletin',
          // title: true
        },
        {
          name: 'adm.contents.EntityManagement.DM.header',
          icon: 'fa-database',
          url: '/adm/document',
          // title: true
        },
        // {
        //   name: 'adm.contents.EntityManagement.productManagement.header',
        //   icon: 'fa-database',
        //   url: '/adm/product',
        //   // title: true
        // },

        {
          name: 'osm.provider.header',
          icon: 'fa-building',
          url: '/adm/provider/list'
        },
        {
          name: 'osm.product.header',
          icon: 'fa-file-contract',
          url: '/adm/product/list'
        },
        {
          name: 'adm.contents.EntityManagement.Core.header',
          icon: 'fa-database',
          title: true,
          children: [{
              name: 'adm.contents.EntityManagement.Core.contact.title',
              url: '/adm/entity-management/core/contact',
              icon: 'fa-list-ol',
            },
            // {
            //   name: 'adm.contents.EntityManagement.Core.customer.title',
            //   url: '/adm/entity-management/core/customer',
            //   icon: 'fa-list-ol',
            // },
            {
              name: 'adm.contents.EntityManagement.Core.team.title',
              url: '/adm/entity-management/core/team',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.Core.lead.title',
              url: '/adm/entity-management/core/lead',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.Core.user.title',
              url: '/adm/entity-management/core/user',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.Core.address.title',
              url: '/adm/entity-management/core/address',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.Core.message.title',
              url: '/adm/entity-management/core/message',
              icon: 'fa-list-ol',
            }
          ]
        },

        {
          name: 'adm.contents.EntityManagement.OSMLife.header',
          icon: 'fa-database',
          title: true,
          children: [{
              name: 'adm.contents.EntityManagement.OSMLife.policy.title',
              url: '/adm/entity-management/life/policy',
              icon: 'fa-list-ol',
            },
            // {
            //   name: 'Policy Premium',
            //   url: '/adm/entity-management/life/policy-premium',
            //   icon: 'fa-list-ol',
            // },
            // {
            //   name: 'Payment History',
            //   url: '/adm/entity-management/life/payment-history',
            //   icon: 'fa-list-ol',
            // },
            // {
            //   name: 'Policy Fund',
            //   url: '/adm/entity-management/life/policy-fund',
            //   icon: 'fa-list-ol',
            // },
            {
              name: 'adm.contents.EntityManagement.OSMLife.investmentStrategy.title',
              url: '/adm/entity-management/life/investment-strategy',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.OSMLife.transactionHistory.title',
              url: '/adm/entity-management/life/transaction-history',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.OSMLife.outstandingRequirement.title',
              url: '/adm/entity-management/life/outstanding-requirement',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.OSMLife.outstandingRequirementComment.title',
              url: '/adm/entity-management/life/outstanding-requirement-comment',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.OSMLife.insuredBenefits.title',
              url: '/adm/entity-management/life/insured-benefits',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.OSMLife.pendingOperation.title',
              url: '/adm/entity-management/life/pending-operation',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.OSMLife.commission.title',
              url: '/adm/entity-management/life/commission',
              icon: 'fa-list-ol',
            },
            {
              name: 'adm.contents.EntityManagement.OSMLife.commissionOverride.title',
              url: '/adm/entity-management/life/commission-override',
              icon: 'fa-list-ol',
            }
          ]
        },
        {
          name: 'adm.contents.EntityManagement.OSMGI.header',
          icon: 'fa-database',
          title: true,
          children: [{
            name: 'adm.contents.EntityManagement.OSMGI.generalPolicy.title',
            url: '/adm/entity-management/gi/general-policy',
            icon: 'fa-list-ol',
          }, ]
        }
      ]
    }
  ],
  // NavItems for Admin Role
  Admin: [{
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
    //  {
    //   name: 'My Page',
    //   url: '/my',
    //   icon: 'fa-list-ol'
    // },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/profile'
      }]
    },
    {
      name: 'crm.title',
      url: '/crm/lead',
      icon: 'fa-users',
      children: [{
          name: 'crm.lead.header',
          icon: 'fa-leaf',
          url: '/crm/lead/list'
        }, {
          name: 'crm.customer.header',
          icon: 'fa-address-book',
          url: '/crm/customer/list'
        },
        {
          name: 'crm.calendar.header',
          icon: 'fa-calendar-alt',
          url: '/crm/calendar'
        },
        {
          name: 'crm.Notification.header',
          icon: 'fa-bell',
          url: '/crm/notification'
        }
      ]
    },

    {
      name: 'osm.title',
      url: '/osm',
      icon: 'fa-asterisk',
      children: [{
          name: 'osm.contents.giPolicy.header',
          icon: 'fa-code-branch',
          url: '/osm/gi/list'
        }, {
          name: 'osm.contents.lifePolicy.header',
          icon: 'fa-heart',
          url: '/osm/life/list'
        },
        {
          name: 'osm.serviceRequest.header',
          icon: 'fa-concierge-bell',
          url: '/osm/sr/list'
        },
        {
          name: 'osm.claim.header',
          icon: 'fa-retweet',
          url: '/osm/claim/list'
        },
        {
          name: 'osm.renewal.quickRenew',
          icon: 'fa-retweet',
          url: '/osm/renewal/renew',
        }, {
          name: 'x U Life Policy (TBC)',
          title: true,
          icon: '',
        },
        {
          name: 'x ILAS (TBC)',
          title: true,
          icon: '',
        }
      ]
    },

    {
      name: 'dw.header',
      url: '/dw',
      icon: 'fa-warehouse',
      children: [{
          name: 'dw.report.header',
          title: true,
          icon: 'fa-file',
          children: [{
              name: 'dw.report.birthday.header',
              url: '/dw/report/birthday',
              icon: 'fa-chart-line'
            }, {
              name: 'dw.report.customer.header',
              url: '/dw/report/customer',
              icon: 'fa-users'
            },
            {
              name: 'dw.report.performance.header',
              url: '/dw/report/performance',
              icon: 'fa-chart-line'
            },
            {
              name: 'dw.report.sale.header',
              url: '/dw/report/sale',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.agentCommission.header',
              url: '/dw/report/fc-commission',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.companyCommission.header',
              url: '/dw/report/company-commission',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.renewal.header',
              url: '/dw/report/renewal',
              icon: 'fa-credit-card'
            }, {
              name: 'dw.report.giPolicy.header',
              url: '/dw/report/giPolicy',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.lifePolicy.header',
              url: '/dw/report/lifePolicy',
              icon: 'fa-credit-card'
            },     {
              name: 'dw.report.claim.header',
              url: '/dw/report/claim',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.sr.navHeader',
              url: '/dw/report/sr',
              icon: 'fa-credit-card'
            },
            // {
            //   name: 'dw.report.commission.header',
            //   url: '/dw/report/commission',
            //   icon: 'fa-credit-card'
            // }
          ]
        },
        {
          name: 'dw.form.header',
          title: true,
          icon: 'fa-download',
          url: '/dw/form/list'
        }
      ]
    },
    {
      name: 'adm.header',
      url: '/adm',
      icon: 'fa-briefcase',
      children: [{
          name: 'adm.cpd.cpd',
          icon: 'fa-school',
          title: true,
          children: [{
              name: 'adm.cpd.list.shortHeader',
              url: '/adm/cpd/list',
              icon: 'fa-calendar-plus'
            },
            {
              name: 'adm.cpd.agentShortHeader',
              url: '/adm/cpd/agent',
              icon: 'fa-star-half-alt'
            }
          ]
        }, {
          name: 'adm.userAuthorization.title',
          icon: 'fa-user-secret',
          url: '/adm/authorization',
          // title: true
        },
        {
          name: 'adm.agent.header',
          url: '/adm/agent/list',
          icon: 'fa-list-ol',
        },
        {
          name: 'adm.agentCommission.header',
          url: '/adm/agent-commission',
          icon: 'fa-list-ol',
        },
        {
          name: 'adm.companyCommission.header',
          url: '/adm/company-commission',
          icon: 'fa-list-ol'
        }, {
          name: 'adm.team.header',
          url: '/adm/team/list',
          icon: 'fa-list-ol',
        },
        {
          name: 'adm.auditTrail.title',
          icon: 'fa-database',
          url: '/adm/audit-trail',
          // title: true
        },
        {
          name: 'adm.bulletin.title',
          icon: 'fa-database',
          url: '/adm/bulletin',
          // title: true
        },
        {
          name: 'adm.contents.EntityManagement.DM.header',
          icon: 'fa-database',
          url: '/adm/document',
          // title: true
        },
        // {
        //   name: 'adm.contents.EntityManagement.productManagement.header',
        //   icon: 'fa-database',
        //   url: '/adm/product',
        //   // title: true
        // },

        {
          name: 'osm.provider.header',
          icon: 'fa-building',
          url: '/adm/provider/list'
        },
        {
          name: 'osm.product.header',
          icon: 'fa-file-contract',
          url: '/adm/product/list'
        },
      ]
    }
  ],

  // NavItems for Agent Role
  Agent: [{
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/profile'
      }]
    },
    {
      name: 'crm.title',
      url: '/crm/lead',
      icon: 'fa-users',
      children: [{
          name: 'crm.lead.header',
          icon: 'fa-leaf',
          url: '/crm/lead/list'
        }, {
          name: 'crm.customer.header',
          icon: 'fa-address-book',
          url: '/crm/customer/list'
        },
        {
          name: 'crm.calendar.header',
          icon: 'fa-calendar-alt',
          url: '/crm/calendar'
        },
        {
          name: 'crm.Notification.header',
          icon: 'fa-bell',
          url: '/crm/notification'
        }
      ]
    },
    {
      name: 'osm.title',
      url: '/osm',
      icon: 'fa-asterisk',
      children: [{
          name: 'osm.contents.giPolicy.header',
          icon: 'fa-code-branch',
          url: '/osm/gi/list'
        }, {
          name: 'osm.contents.lifePolicy.header',
          icon: 'fa-heart',
          url: '/osm/life/list'
        },
        {
          name: 'osm.serviceRequest.header',
          icon: 'fa-concierge-bell',
          url: '/osm/sr/list'
        },
        {
          name: 'osm.claim.header',
          icon: 'fa-retweet',
          url: '/osm/claim/list'
        }, {
          name: 'osm.renewal.quickRenew',
          icon: 'fa-retweet',
          url: '/osm/renewal/renew',
        },
        {
          name: 'x U Life Policy (TBC)',
          title: true,
          icon: '',
        },
        {
          name: 'x ILAS (TBC)',
          title: true,
          icon: '',
        }
      ]
    },
    {
      name: 'dw.header',
      url: '/dw',
      icon: 'fa-warehouse',
      children: [{
          name: 'dw.form.header',
          title: true,
          icon: 'fa-download',
          url: '/dw/form/list'
        },
        {
          name: 'dw.report.header',
          title: true,
          icon: 'fa-file',
          children: [{
              name: 'dw.report.birthday.header',
              url: '/dw/report/birthday',
              icon: 'fa-chart-line'
            }, {
              name: 'dw.report.customer.header',
              url: '/dw/report/customer',
              icon: 'fa-users'
            },
            {
              name: 'dw.report.performance.header',
              url: '/dw/report/performance',
              icon: 'fa-chart-line'
            },
            {
              name: 'dw.report.sale.header',
              url: '/dw/report/sale',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.agentCommission.header',
              url: '/dw/report/fc-commission',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.renewal.header',
              url: '/dw/report/renewal',
              icon: 'fa-credit-card'
            }, {
              name: 'dw.report.giPolicy.header',
              url: '/dw/report/giPolicy',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.lifePolicy.header',
              url: '/dw/report/lifePolicy',
              icon: 'fa-credit-card'
            },
                 {
              name: 'dw.report.claim.header',
              url: '/dw/report/claim',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.sr.navHeader',
              url: '/dw/report/sr',
              icon: 'fa-credit-card'
            },
            // {
            //   name: 'dw.report.commission.header',
            //   url: '/dw/report/commission',
            //   icon: 'fa-credit-card'
            // }
          ]
        },
      ]
    },
  ],

  // NavItems for Client Role
  Client: [{
      name: 'hm',
      url: '/customer-dashboard',
      icon: 'fa-home'
    },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/customer-profile'
      }]
    },

  ],

  // NavItems for Assistant Role
  Assistant: [{
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/profile'
      }]
    },
    {
      name: 'crm.title',
      url: '/crm/lead',
      icon: 'fa-users',
      children: [{
          name: 'crm.lead.header',
          icon: 'fa-leaf',
          url: '/crm/lead/list'
        }, {
          name: 'crm.customer.header',
          icon: 'fa-address-book',
          url: '/crm/customer/list'
        },
        {
          name: 'crm.calendar.header',
          icon: 'fa-calendar-alt',
          url: '/crm/calendar'
        }
      ]
    },
    {
      name: 'osm.title',
      url: '/osm',
      icon: 'fa-asterisk',
      children: [{
          name: 'osm.contents.giPolicy.header',
          icon: 'fa-code-branch',
          url: '/osm/gi/list'
        }, {
          name: 'osm.contents.lifePolicy.header',
          icon: 'fa-heart',
          url: '/osm/life/list'
        },
        {
          name: 'osm.serviceRequest.header',
          icon: 'fa-concierge-bell',
          url: '/osm/sr/list'
        },
        {
          name: 'osm.claim.header',
          icon: 'fa-retweet',
          url: '/osm/claim/list'
        }, {
          name: 'osm.renewal.quickRenew',
          icon: 'fa-retweet',
          url: '/osm/renewal/renew',
        },
        {
          name: 'x U Life Policy (TBC)',
          title: true,
          icon: '',
        },
        {
          name: 'x ILAS (TBC)',
          title: true,
          icon: '',
        }
      ]
    },
    {
      name: 'dw.header',
      url: '/dw',
      icon: 'fa-warehouse',
      children: [{
        name: 'dw.form.header',
        title: true,
        icon: 'fa-download',
        url: '/dw/form/list'
      }]
    },
  ],
  // NavItems for Manager Role
  Manager: [{
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/profile'
      }]
    },
    {
      name: 'crm.title',
      url: '/crm/lead',
      icon: 'fa-users',
      children: [{
          name: 'crm.lead.header',
          icon: 'fa-leaf',
          url: '/crm/lead/list'
        }, {
          name: 'crm.customer.header',
          icon: 'fa-address-book',
          url: '/crm/customer/list'
        },
        {
          name: 'crm.calendar.header',
          icon: 'fa-calendar-alt',
          url: '/crm/calendar'
        }
      ]
    },
    {
      name: 'osm.title',
      url: '/osm',
      icon: 'fa-asterisk',
      children: [{
          name: 'osm.contents.giPolicy.header',
          icon: 'fa-code-branch',
          url: '/osm/gi/list'
        }, {
          name: 'osm.contents.lifePolicy.header',
          icon: 'fa-heart',
          url: '/osm/life/list'
        },
        {
          name: 'osm.serviceRequest.header',
          icon: 'fa-concierge-bell',
          url: '/osm/sr/list'
        },
        {
          name: 'osm.claim.header',
          icon: 'fa-retweet',
          url: '/osm/claim/list'
        }, {
          name: 'osm.renewal.quickRenew',
          icon: 'fa-retweet',
          url: '/osm/renewal/renew',
        },
        {
          name: 'x U Life Policy (TBC)',
          title: true,
          icon: '',
        },
        {
          name: 'x ILAS (TBC)',
          title: true,
          icon: '',
        }
      ]
    },
    {
      name: 'dw.header',
      url: '/dw',
      icon: 'fa-warehouse',
      children: [{
          name: 'dw.form.header',
          title: true,
          icon: 'fa-download',
          url: '/dw/form/list'
        },
        {
          name: 'dw.report.header',
          title: true,
          icon: 'fa-file',
          children: [{
              name: 'dw.report.birthday.header',
              url: '/dw/report/birthday',
              icon: 'fa-chart-line'
            }, {
              name: 'dw.report.customer.header',
              url: '/dw/report/customer',
              icon: 'fa-users'
            },
            {
              name: 'dw.report.performance.header',
              url: '/dw/report/performance',
              icon: 'fa-chart-line'
            },
            {
              name: 'dw.report.sale.header',
              url: '/dw/report/sale',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.agentCommission.header',
              url: '/dw/report/fc-commission',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.renewal.header',
              url: '/dw/report/renewal',
              icon: 'fa-credit-card'
            }, {
              name: 'dw.report.giPolicy.header',
              url: '/dw/report/giPolicy',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.lifePolicy.header',
              url: '/dw/report/lifePolicy',
              icon: 'fa-credit-card'
            },
                 {
              name: 'dw.report.claim.header',
              url: '/dw/report/claim',
              icon: 'fa-credit-card'
            },
            {
              name: 'dw.report.sr.navHeader',
              url: '/dw/report/sr',
              icon: 'fa-credit-card'
            },
            // {
            //   name: 'dw.report.commission.header',
            //   url: '/dw/report/commission',
            //   icon: 'fa-credit-card'
            // }
          ]
        }
      ]
    },
  ],
  // NavItems for CE Role
  CE: [{
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/profile'
      }]
    },

  ],


  // NavItems for Super Admin Role
  SuperAdmin: [{
      name: 'hm',
      url: '/dashboard',
      icon: 'fa-home'
    },
    {
      name: 'my.header',
      url: '/my',
      icon: 'fa-user-circle',
      children: [{
        name: 'my.profile.header',
        icon: 'fa-address-card',
        url: '/my/profile'
      }]
    },

  ],

}



// WEBPACK FOOTER //
// ./src/_nav.js